import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';
import VideoCard from '@/components/base/VideoCard';

export default function PopularVideos() {
  const popularVideos = videos.slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门樱花视频
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              全网樱花爱好者都在看的高清视频
            </p>
          </div>
          <Link
            to="/category/japan-sakura"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {popularVideos.map((video) => (
            <VideoCard key={video.id} {...video} />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/japan-sakura"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium"
          >
            查看全部视频 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}